import React, { useEffect, useRef } from 'react';

const achievements = [
    {
        year: '2024',
        items: [
            'Trusted partner for 500+ businesses across UAE',
            'Completed 1000+ signage projects successfully',
            'Expanded services to cover all Emirates'
        ]
    },
    {
        year: '2023',
        items: [
            'Launched advanced LED and neon fabrication facility',
            'Partnered with major retail chains across Abu Dhabi',
            'Introduced eco-friendly signage materials'
        ]
    },
    {
        year: '2022',
        items: [
            'Established as leading signage provider in Musaffah',
            'Completed major corporate branding projects',
            'Expanded team of skilled fabricators and installers'
        ]
    }
];

const clients = [
    'Retail Outlets',
    'Restaurants & Cafes',
    'Corporate Offices',
    'Real Estate Developers',
    'Healthcare Facilities',
    'Educational Institutions',
    'Government Organizations',
    'Hotels & Resorts'
];

function Achievements() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.1
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, observerOptions);

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <section className="achievements-section" ref={sectionRef}>
            <div className="container-wide">
                <div className="achievements-grid">
                    <div className="achievements-column">
                        <div className="section-header-new">
                            <h2 className="section-title-new">MILESTONES & ACHIEVEMENTS</h2>
                        </div>

                        <div className="achievements-timeline">
                            {achievements.map((achievement, index) => (
                                <div key={index} className="achievement-year-block">
                                    <div className="achievement-year">{achievement.year}</div>
                                    <ul className="achievement-list">
                                        {achievement.items.map((item, idx) => (
                                            <li key={idx}>• {item}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="achievements-column">
                        <div className="section-header-new">
                            <h2 className="section-title-new">OUR CLIENTS</h2>
                        </div>

                        <div className="clients-grid">
                            {clients.map((client, index) => (
                                <div key={index} className="client-tag">
                                    {client}
                                </div>
                            ))}
                        </div>

                        <div className="client-stats">
                            <div className="stat-item">
                                <h3 className="stat-number">100+</h3>
                                <p className="stat-label">Happy Clients</p>
                            </div>
                            <div className="stat-item">
                                <h3 className="stat-number">400+</h3>
                                <p className="stat-label">Projects Completed</p>
                            </div>
                            <div className="stat-item">
                                <h3 className="stat-number">4+</h3>
                                <p className="stat-label">Years Experience</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Achievements;
